<template>

  <div class="account-page account-bookings" :class="{active: active}" :data-account-page="id">
    <div class="tabbed">

      <div class="tab-header">

        <internal-nav class="tabs" :active-item="activeSubpage" :items="navItems" @select="changePage"></internal-nav>

        <div class="table-actions mobile-break">
          <div class="action">
            <button type="button" class="rounded small" :class="{current: mode === 'list'}" @click="mode = 'list'">
              List
            </button>
          </div>

          <div class="action">
            <button type="button" class="rounded small" :class="{current: mode === 'calendar'}"
                    @click="mode = 'calendar'">
              Calendar
            </button>
          </div>
        </div>

      </div>
      <!-- /.tab-header -->

      <div class="content-panes view-switchable" :class="['mode-' + mode]" v-if="active || wasActive">

        <div id="bookings-active" class="content-pane" :class="{active: (activeSubpage === 'index')}">
          <div class="view view-list" :class="{active: isListView}">
            <listing type="booking-item" data-url="/api/account/bookings"
                     v-if="isActivatedSubpage('index')"></listing>
          </div>
          <div class="view view-calendar" :class="{active: isCalendarView}">
            <calendar-view data-url="/api/account/bookings" v-if="isActivatedSubpage('index')"></calendar-view>
          </div>
        </div>

        <!-- <div id="bookings-on-hold" class="content-pane" :class="{active: (activeSubpage === 'on-hold')}">
          <div class="view view-list" :class="{active: isListView}">
            <listing type="booking-item" data-url="/api/account/bookings/on-hold"
                     v-if="isActivatedSubpage('on-hold')"></listing>
          </div>
          <div class="view view-calendar" :class="{active: isCalendarView}">
            <calendar-view data-url="/api/account/bookings/on-hold"
                           v-if="isActivatedSubpage('on-hold')"></calendar-view>
          </div>
        </div> -->

        <div id="bookings-cancelled" class="content-pane" :class="{active: (activeSubpage === 'cancelled')}">
          <div class="view view-list" :class="{active: isListView}">
            <listing type="booking-item" data-url="/api/account/bookings/cancelled"
                     v-if="isActivatedSubpage('cancelled')"></listing>
          </div>
          <div class="view view-calendar" :class="{active: isCalendarView}">
            <calendar-view data-url="/api/account/bookings/cancelled"
                           v-if="isActivatedSubpage('cancelled')"></calendar-view>
          </div>
        </div>

        <div id="bookings-completed" class="content-pane" :class="{active: (activeSubpage === 'complete')}">
          <div class="view view-list" :class="{active: isListView}">
            <listing type="booking-item" data-url="/api/account/bookings/completed"
                     v-if="isActivatedSubpage('complete')"></listing>
          </div>
          <div class="view view-calendar" :class="{active: isCalendarView}">
            <calendar-view data-url="/api/account/bookings/completed"
                           v-if="isActivatedSubpage('complete')"></calendar-view>
          </div>
        </div>

      </div>
      <!-- /.content-panes -->

    </div>
    <!-- /.tabbed -->

  </div>

</template>

<script>
import Vue from 'vue'
import BookingItem from './elements/Booking'
import AccountSubpage from '../../../AccountSubpage'

Vue.component('booking-item', BookingItem)

export default {
  extends: AccountSubpage,
  data () {
    return {
      id: 'bookings',
      mode: (localStorage['bookingsViewMode']) ? localStorage['bookingsViewMode'] : 'list',
    }
  },
  computed: {
    isCalendarView () {
      return (this.mode === 'calendar')
    },
    isListView () {
      return (this.mode === 'list')
    },
    navItems () {
      return [
        { id: 'index', label: 'Active' },
        { id: 'complete', label: 'Completed' },
        { id: 'on-hold', label: 'On Hold' },
        { id: 'cancelled', label: 'Cancelled / Expired' }
      ]
    }
  },
  watch: {
    mode () {
      localStorage['bookingsViewMode'] = this.mode
    }
  }
}
</script>
